/**
 * The open project's position in the tab strip (1–9, the ⌥N it switches with), for the composer's
 * target chip. Undefined outside a project tab or past the ninth tab.
 */
import { createContext, useContext } from 'react'

export const TabNumberContext = createContext<number | undefined>(undefined)
export const useTabNumber = () => useContext(TabNumberContext)

/** 1-based tab number of `projectId` in the pinned order, when it has a key (1–9). */
export function tabNumberOf(pinned: readonly { id: string }[], projectId: string) {
  const i = pinned.findIndex((p) => p.id === projectId)
  return i >= 0 && i < 9 ? i + 1 : undefined
}
